// pages/FormViewerPage/services/formViewerService/pixelOptimization.ts
// FORM-ONLY (2026-09-29, permintaan user): pixel yg fire HANYA yg di-assign di
// formulir. Merge pixel optimasi global DIMATIKAN total — dulu pixel brand X
// (adsOptimized && brandId === X, mis. 2447... GERD) otomatis nempel ke semua
// form brand X (mis. Salep Yudaifu ikut nembak pixel GERD) = polusi lintas produk.
// Fungsi di bawah dipertahankan (tanda sama) sbg pass-through biar 12 pemanggil
// tidak perlu disentuh; UI /pengaturan/pelacakan kolom Optimasi di-disable.

export interface OptimizablePixel {
    id?: string;
    brandId?: string;
    adsOptimized?: boolean;
}

// DIMATIKAN: selalu kosong (form-only). Param dipertahankan biar caller tetap kompilasi.
export function getOptimizationPixelIds(
    _globalPixels: OptimizablePixel[] | undefined | null,
    _brandId: string | undefined | null
): string[] {
    return [];
}

// FORM-ONLY: kembalikan pixel form apa adanya (trim + filter kosong + dedup).
// Param global/brand diabaikan (optimasi global dimatikan 2026-09-29).
export function withOptimizationPixels(
    formIds: string[] | undefined | null,
    _globalPixels: OptimizablePixel[] | undefined | null,
    _brandId: string | undefined | null
): string[] {
    const out: string[] = [];
    for (const id of (formIds || []).map(x => x?.trim()).filter(Boolean)) {
        if (!out.includes(id)) out.push(id);
    }
    return out;
}

export interface PlatformPixelConfigLike {
    platform?: string;
    pixelIds?: string[];
}

// Ambil daftar pixel satu platform dari configs builder (murni, untuk mid-funnel).
export function pickPlatformPixelIds(
    allConfigs: PlatformPixelConfigLike[] | undefined | null,
    platform: string
): string[] {
    if (!Array.isArray(allConfigs)) return [];
    const found = allConfigs.find(c => c?.platform === platform);
    return (found?.pixelIds || []).map(id => id?.trim()).filter(Boolean);
}
